module.exports = __webpack_public_path__ + "img/private.b3cf9945.svg";